import { useState, useEffect } from 'react';
import { BRAND, FONTS } from '../styles/tokens';
import { useIsMobile } from '../hooks/useIsMobile';

export function ScrollProgress() {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const h = () => { const d = document.documentElement; setPct((d.scrollTop / (d.scrollHeight - d.clientHeight)) * 100); };
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return <div style={{ position: 'fixed', top: 0, left: 0, height: 3, width: `${pct}%`, background: `linear-gradient(90deg, ${BRAND.warm}, ${BRAND.warmDark})`, zIndex: 200, transition: 'width 0.1s linear' }} />;
}

interface FloatingCTAProps { onNav: (id: string) => void }

export function FloatingCTA({ onNav }: FloatingCTAProps) {
  const [show, setShow] = useState(false);
  const isMobile = useIsMobile();
  useEffect(() => {
    const h = () => {
      const leadEl = document.getElementById('lead');
      const atLead = leadEl ? leadEl.getBoundingClientRect().top < window.innerHeight * 0.8 : false;
      setShow(window.scrollY > 800 && !atLead);
    };
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <button onClick={() => onNav('lead')} style={{
      position: 'fixed',
      bottom: isMobile ? 20 : 28,
      right: isMobile ? 16 : 28,
      left: isMobile ? 16 : 'auto',
      zIndex: 140,
      background: BRAND.warm, color: BRAND.navy, border: 'none',
      padding: isMobile ? '16px 24px' : '14px 28px',
      borderRadius: isMobile ? 14 : 50,
      fontSize: isMobile ? 15 : 14, fontWeight: 700,
      fontFamily: FONTS.body, cursor: 'pointer',
      boxShadow: '0 8px 32px rgba(124,58,165,0.4)',
      opacity: show ? 1 : 0,
      transform: show ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.9)',
      transition: 'all 0.35s ease',
      pointerEvents: show ? 'auto' : 'none',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
    }}>
      📩 Get Free Guide
    </button>
  );
}
